import React from "react";
import { SkillsGridRowPart } from "./SkillsGridRowPart";
import { dataTestIds } from "data-testids";

export interface ISkillGridRowEntry {
  categoryName: string;
  categoryId: number;
  rows: {
    levelId?: number;
    level?: string;
    skills: string[];
  }[];
}

export interface ISkillsGridProps {
  skills: ISkillGridRowEntry[];
}

export const SkillsGrid: React.FC<
  React.PropsWithChildren<ISkillsGridProps>
> = ({ skills }) => {
  const rows = skills.map((skill) => (
    <tr
      className="c-skill-grid__row"
      key={skill.categoryId}
      data-testid={dataTestIds.profile["SkillsGrid.SkillsGrid-data-row"]}
    >
      {skill.rows.map((row, index) => (
        <SkillsGridRowPart
          key={row.levelId || -index}
          name={index === 0 ? skill.categoryName : undefined}
          level={row.level}
          skillsName={row.skills}
        />
      ))}
    </tr>
  ));

  return <table className="c-skill-grid">{rows}</table>;
};
